<template>
	<div >
		<div v-if="getAuthStep==1">
			<div class="text-center">

				<div v-html="html" class="pre-formatted"> </div>
				<p class="page-title">BACK TO WORK  </p>
				<p class="head--text">Fill in your login details below.</p>
			</div>
			<div class="h-100">
				<v-form ref="login_form"  lazy-validation  @submit.prevent="login()">
					<v-row justify="center" class="pt-5 text-center">
						<v-col cols="6" md="4" class="px-5">
							<v-text-field
							:label="$lang.MOBILE_NO"
							v-model="mobile"
							single-line
							outlined
							dense
							maxlength="10"
							></v-text-field>

							<v-text-field
							:label="$lang.PASSWORD"
							v-model="password"
							single-line
							outlined
							dense
							:rules="rules.PasswordRule"
							type="password"
							v-if="$route.name=='wholesaler-login'"
							></v-text-field>
							<div v-if="$route.name=='wholesaler-login'" class="text-right messge-text-green cursor-pointer" style="margin-top:-15px; z-index:10; position:relative" @click="$router.push({name:'forget-password'})">{{$lang.FORGOT_PASSWORD}}</div>

							<v-btn color="primary" type="submit" class="signup-btn-style mt-5"  :loading="loding">
								Login
							</v-btn>	
						</v-col>
					</v-row>
				</v-form>
			</div>
		</div>

		<div v-if="getAuthStep==2">
			<verify-otp :otp="otp" :shouldAutoFocus="shouldAutoFocus" />
		</div>
	</div>
</template>


<script type="text/javascript">

import messages  from '../../../app-js/messages.js'
import { mapGetters } from 'vuex'
export default {
	components: {
		VerifyOtp: () => import('../verify-otp/VerifyOtp.vue'),
	},
	data () {
		return {
			mobile:"",
			password:"",
			otp:"",
			loding:false,
			login_type:"",
			html:"",
			rules:{
				mobileRule: [
				v=>!!v || messages.MOBILE_NUMBER_ERROR,
				v  => {
					if (!v.trim()) return true;
					if (!isNaN(parseFloat(v)) && v >= 5000000000 && v <= 9999999999) return true;
					return messages.INVALID_MOBILE_NUMBER_ERROR;
				}
				],
				PasswordRule: [v => !!v || messages.PASSWORD_ERROR],
			},
			shouldAutoFocus:false,
		}
	},
	computed: mapGetters({
		getAuthStep: 'auth/getAuthStep'
	}),
	created(){
		this.$store.dispatch('auth/setAuthStep', 1)
	},
	methods:{

		login(){
			const self=this;
			let acepted_user_type=[this.$keys.WAREHOUSE,this.$keys.SUPER_ADMIN]
			if (this.$route.name=='wholesaler-login')
				acepted_user_type=[this.$keys.WHOLESALER]
			
			if (this.$refs.login_form.validate()==false)
				return false
			self.loding=true
			var	form = new FormData();
			form.append("mobile",self.mobile);
			form.append("password",self.password);


			const successHandler = (response) => {
				console.log(response)
				if (response.data.success){
					if(response.data.flag_otp_verified==false) {
						this.$store.dispatch('auth/setOtpToken', {otp_token:response.headers["otp-token"], mobile:self.mobile, email:"",action:"" })
						this.$store.dispatch('auth/setAuthStep', 2)
					}
					else{

						console.log(acepted_user_type)
						if (!acepted_user_type.includes(response.data.account_type)){
							this.$store.dispatch('snackbar/setSnackbar', {flag:true, text:"Invalid credentials", color:'error' })
							return false
						}

						this.$store.dispatch('setUserType', response.data.account_type)
						sessionStorage.setItem("user_type", response.data.account_type);

						if(response.data.account_type==self.$keys.WHOLESALER){
							sessionStorage.setItem("token", response.headers.token);
						}


						/* if ware house  login reirect to  verifucaion page*/ 
						if(response.data.account_type!=self.$keys.WHOLESALER){
							this.$store.dispatch('auth/setOtpToken', {otp_token:response.headers["otp-token"], mobile:self.mobile, email:"",action:"" })
							this.$store.dispatch('auth/setAuthStep', 2)
							this.otp=response.data.otp
							let x = document.getElementsByClassName("input-block");
							console.log(x[0])
							x[0].focus()
							// let y =x.getElementsByTagName("input")[0].focus();
							// console.log(y)
						}
						else{
							self.$router.push({name:"overview"})
						}
					}
				}
			};
			const finallyHandler = () => {
				self.loding=false
			};

			this.request_POST(self,this.$urls.LOGIN,form,successHandler,null,null,finallyHandler)

		}

	}

}
</script>